module.exports = __webpack_public_path__ + "img/xlc.3b75fffc.png";